// extracted by mini-css-extract-plugin
export var image = "promoted-post-module--image--gs+cW";
export var imageWrapper = "promoted-post-module--image-wrapper---eo5K";
export var lead = "promoted-post-module--lead--S1NHN";
export var metaWrapper = "promoted-post-module--meta-wrapper--KUKNX";
export var promotedPost = "promoted-post-module--promoted-post--FHmOn";
export var superTitle = "promoted-post-module--super-title--IUYkB";
export var title = "promoted-post-module--title--mp2Q9";